module.exports = __webpack_public_path__ + "static/media/  (35).01ecf253.jpg";